import { groupUserControllerGetCurrentUser } from "@/lib/gen-api/sdk.gen";
import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { GroupRole } from "../lib/consts";
import { queryKeys } from "../lib/query-keys";

export const useGroupUserMeData = (groupUuid: string | null) => {
  const isApiReady = useIsApiReady();

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.groupUserMe(groupUuid ?? ""),
    queryFn: () =>
      groupUserControllerGetCurrentUser({
        path: { groupUuid: groupUuid! },
      }),
    enabled: isApiReady && !!groupUuid,
    select: (res) => res.data,
  });

  return {
    groupRole: (data?.groupRole ?? null) as GroupRole | null,
    organizationRole: data?.organizationRole ?? null,
    teamGroupAdmin: data?.teamGroupAdmin ?? false,
    isLoading,
  };
};
